import { VscExtensions } from 'react-icons/vsc'
import PluginList from './PluginList'
import PluginShow from './PluginShow'

export default {
  icon: VscExtensions,
  list: PluginList,
  show: PluginShow,
}
